import { Box, SvgIcon } from '@mui/material';

export const InactiveIcon = (props) => {
  return (
    <Box
      sx={{
        width: props.sx ? props.sx.width : 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: props.sx ? props.sx.height : 16,
        backgroundColor: '#E1E3E8',
        borderRadius: '50%',
      }}
    >
      <SvgIcon {...props}>
        <svg
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        ></svg>
      </SvgIcon>
    </Box>
  );
};
